// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin_main__17uu4,\n.admin_mainFullWidth__3nUDo {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 80px);\n  height: 100vh;\n  overflow: hidden;\n  background: #fafafa;\n  padding: 0; }\n\n.admin_mainFullWidth__3nUDo {\n  width: 100%; }\n\n.admin_appContent__L7ZfC {\n  display: flex;\n  overflow: hidden;\n  max-height: 100vh; }\n", ""]);
// Exports
exports.locals = {
	"main": "admin_main__17uu4",
	"mainFullWidth": "admin_mainFullWidth__3nUDo",
	"appContent": "admin_appContent__L7ZfC"
};
module.exports = exports;
